import { useCallback, useState } from "react"
import "./index.css"
import Glass from "../../../glass"

const List = ({ options, def, onEditComplete }) => {

    const [selectedOptions, setSelectedOptions] = useState(def || [])
    const [showList, setShowList] = useState(false)

    const handleItemClick = (o, e) => {
        setSelectedOptions(p => p.indexOf(o) == -1 ? [...p, o] : p.filter(pp => pp != o))
    }

    const handleDone = e => {
        setShowList(false)
        e.stopPropagation()
        onEditComplete && onEditComplete(selectedOptions)
    }

    return (
        <div className="list-root" onClick={() => setShowList(true)}>

            {showList &&
                <div className="list-popup-cont">
                    <Glass dark />
                    <div className="list-popup">
                        {
                            options.map(o => <div className={`list-item ${selectedOptions.indexOf(o) != -1 ? 'selected' : ''}`}
                                onClick={e => handleItemClick(o, e)}>{o}</div>)
                        }
                        <div className="list-item list-done" onClick={handleDone}>Done</div>
                    </div>
                </div>
            }

            {
                selectedOptions ? selectedOptions.join(', ') :
                    <div className="list-placeholder">Click to select from the list...</div>
            }
        </div >
    )
}

export default List